// Fetch interceptor is set up in utils/templateInjectionBKA.js
// It must run first to wrap fetch before any other code uses it

const urlParams = new URLSearchParams(window.location.search);
const userName = urlParams.get('userName');
if (userName) {
  localStorage.setItem("userName", userName);
};

const host = window.location.host
const validHostPattern = /^app(\.[a-z0-9-]+)?\.erste-hausverwaltung\.de$/

const baseApiUrl =
  host === 'app.local.erste-hausverwaltung.de'
    ? 'http://localhost:3000'
    : validHostPattern.test(host)
      ? `https://${host}`
      : 'https://app.dev.erste-hausverwaltung.de';

const activeObservers = {}

const resolveDomain = (domain) => {
  let resolvedDomain = ""
  switch (domain) {
    case 1115:
      resolvedDomain = 'cig'
      break
    case 1044:
      resolvedDomain = 'erste-hausverwaltung-dus'
      break
    case 1116:
      resolvedDomain = 'zieglmeier'
      break
    case 1572:
      resolvedDomain = 'fraenken'
      break
    case 1015:
      resolvedDomain = 'hauscon'
      break
    case 949:
      resolvedDomain = 'erste-hausverwaltung-2'
      break
    case 2421:
      resolvedDomain = 'ehv-service'
      break
    case 2740:
      resolvedDomain = 'verwey-demo'
      break
    case 3265:
      resolvedDomain = 'sgv-murr'
      break
    default:
      resolvedDomain = domain
  }
  return resolvedDomain
};

const initateAnObserver = (onObserve, selector) => {
  if (typeof onObserve !== 'function') return
  if (activeObservers[selector]) {
    activeObservers[selector].disconnect()
    delete activeObservers[selector]
  }

  const observer = new MutationObserver(onObserve)

  observer.observe(document.querySelector('body'), {
    childList: true,
    subtree: true,
  })

  activeObservers[selector] = observer
};

const onElementPresent = (selector, callback) => {
  initateAnObserver(() => {
    const element = $(selector)
    if (element.length) callback(element)
  }, selector)
};

const domPurifyLoaded = new Promise((resolve) => {
  if (typeof window.DOMPurify !== 'undefined') {
    resolve();
  } else {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/dompurify/3.2.3/purify.min.js';
    script.integrity = 'sha512-Ll+TuDvrWDNNRnFFIM8dOiw7Go7dsHyxRp4RutiIFW/wm3DgDmCnRZow6AqbXnCbpWu93yM1O34q+4ggzGeXVA==';
    script.crossOrigin = 'anonymous';
    script.onload = () => resolve();
    document.head.appendChild(script);
  }
});

domPurifyLoaded.then(() => {
  const onPageChanged = () => {
    const pathname = window.location.pathname

    // Check if navigating to dashboard via SPA - force reload for reverse proxy
    if (pathname === '/dashboard') {
      const isSPANavigation = window.performance && 
        window.performance.getEntriesByType('navigation').length > 0 &&
        window.performance.getEntriesByType('navigation')[0].type === 'navigate'
      
      if (isSPANavigation) {
        window.location.reload()
        return
      }
    }

    onAnyPageMatch()

    // Safety check: only proceed if pagesLookupDictionary is defined and initialized
    if (window.pagesLookupDictionary) {
      for (const key in window.pagesLookupDictionary) {
        const { regex, action } = window.pagesLookupDictionary[key]

        if (regex.test(pathname)) {
          setTimeout(() => {
            action(pathname, regex)
          }, 1000)
          return
        }
      }
    }
  }

  window.addEventListener('load', onPageChanged)
  window.addEventListener('popstate', onPageChanged)

  const originalPushState = history.pushState
  const originalReplaceState = history.replaceState

  history.pushState = (state, title, url) => {
    originalPushState.call(history, state, title, url)
    onPageChanged()
  }

  history.replaceState = (state, title, url) => {
    originalReplaceState.call(history, state, title, url)
    onPageChanged()
  }
})
